<template>
  <!-- <v-menu
    rounded="xl"
    :close-on-content-click="false"
    transition="scale-transition"
    offset-y
    max-width="240"
  >
    <template v-slot:activator="{ on }">
      <v-btn icon v-on="on">
        <v-icon> mdi-plus</v-icon>
      </v-btn>
    </template> -->
  <v-card
    :style="{
      background: $vuetify.theme.themes[theme].background,
    }"
    elevation="5"
    rounded="xl"
    width="250"
    min-height="20"
    class="ma-0 pa-0 pt-2 pl-5"
  >
    <div style="display: flex" class="mt-2">
      <h3>{{ title }}</h3>
      <v-spacer />
      <v-icon size="22" @click="goToTheChangeCard()">mdi-pencil-outline</v-icon>
      <v-icon size="22" @click="deleteThisTask()" class="ml-1 mr-5"
        >mdi-delete-outline</v-icon
      >
    </div>
    <!-- <v-row class="ma-0 pa-0 pt-2">
      <v-col cols="8">
        <h3>{{ title }}</h3>
      </v-col>
      <v-col cols="4" style="display: flex" class="ml-n3">
        <v-icon size="22">mdi-pencil-outline</v-icon>
        <v-icon size="22" class="ml-1">mdi-delete-outline</v-icon>
      </v-col>
    </v-row> -->
    <v-row class="ma-0 pa-0 pr-4">
      <v-list
        elevation="0"
        rounded
        class="ma-0 pa-0"
        :style="{
          background: $vuetify.theme.themes[theme].background,
        }"
      >
        <v-list-item class="ma-0 pa-0">
          <!-- <p class="caption-11 ml-n1" style="color:grey;font-weight:580;">Check different textures and create different versions</p> -->
          <p class="caption-11 pt-1" style="font-weight: 580">
            {{ description }}
          </p>
          <!-- <p>{{ idComp }}{{ slug }}</p> -->
        </v-list-item>
      </v-list>
    </v-row>
  </v-card>
  <!-- </v-menu> -->
</template>

<script>
export default {
  name: "shamsi",
  props: {
    title: {
      type: String,
      default: "John KKJY Do",
    },
    description: {
      type: String,
      default: "John Doefdg",
    },
    slug: {
      type: String,
      default: "Johndsf Doe",
    },
    idComp: {
      type: Number,
      default: 0,
    },
    deleteThisTask: { type: Function },
    goToTheChangeCard: { type: Function },
  },
  computed: {
    theme() {
      return this.$vuetify.theme.dark ? "dark" : "light";
    },
  },
};
</script>

<style>
</style>